var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingbag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.34 49.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.32,47.26,32.11,11.64A2.43,2.43,0,0,0,29.7,9.49H26.15v-1a8.47,8.47,0,0,0-16.94,0v1H5.27a2.45,2.45,0,0,0-2.42,2.24L0,47.35a2.45,2.45,0,0,0,.63,1.84A2.43,2.43,0,0,0,2.43,50H33.91a2.44,2.44,0,0,0,1.82-.82A2.38,2.38,0,0,0,36.32,47.26ZM11,8.47a6.69,6.69,0,0,1,13.38,0v1H11ZM34.4,48a.64.64,0,0,1-.49.21H2.43A.63.63,0,0,1,2,48a.6.6,0,0,1-.17-.49L4.62,11.87a.65.65,0,0,1,.65-.6H9.21v4A1.79,1.79,0,1,0,11,15.13V11.27H24.37v3.91a1.8,1.8,0,1,0,1.78,0V11.27H29.7a.66.66,0,0,1,.65.58l4.21,35.61A.68.68,0,0,1,34.4,48ZM10.22,16.74l0,0v-.05A0,0,0,0,1,10.22,16.74Zm15.06,0,0,0v-.05S25.28,16.72,25.28,16.74Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbag);
export default __webpack_public_path__ + "static/media/shoppingbag.403827a048130ae3b3dcfacec6f84c43.svg";
export { ForwardRef as ReactComponent };